import { AnchorPointPosition } from '../__generated/model/index.js';
const toCornerCoords = (coords, plateSize, position)=>{
    const cornerCoords = {
        x: position === AnchorPointPosition.topLeft || position === AnchorPointPosition.bottomLeft ? coords.x : plateSize.x - coords.x,
        y: position === AnchorPointPosition.topLeft || position === AnchorPointPosition.topRight ? plateSize.y - coords.y : coords.y
    };
    return cornerCoords;
};
export const getHolePositions = (center, plateSize, count)=>{
    const horizontalCount = count.horizontal ?? 0;
    const verticalCount = count.vertical ?? 0;
    if (horizontalCount < 4 && verticalCount < 4) {
        return [];
    }
    const topLeftCoords = toCornerCoords(center, plateSize, AnchorPointPosition.topLeft);
    const topRightCoords = toCornerCoords(center, plateSize, AnchorPointPosition.topRight);
    const bottomLeftCoords = toCornerCoords(center, plateSize, AnchorPointPosition.bottomLeft);
    const bottomRightCoords = toCornerCoords(center, plateSize, AnchorPointPosition.bottomRight);
    const holePositions = [
        topLeftCoords,
        topRightCoords,
        bottomLeftCoords,
        bottomRightCoords
    ];
    if (horizontalCount > 4) {
        const oneSideHoleCount = horizontalCount / 2;
        const stepSize = (topRightCoords.x - topLeftCoords.x) / (oneSideHoleCount - 1);
        const topY = topLeftCoords.y;
        const bottomY = bottomLeftCoords.y;
        for(let i = 1; i < oneSideHoleCount - 1; i++){
            const x = topLeftCoords.x + i * stepSize;
            holePositions.push({
                x,
                y: topY
            });
            holePositions.push({
                x,
                y: bottomY
            });
        }
    }
    if (verticalCount > 4) {
        const oneSideHoleCount = verticalCount / 2;
        const stepSize = (bottomLeftCoords.y - topLeftCoords.y) / (oneSideHoleCount - 1);
        const leftX = topLeftCoords.x;
        const rightX = topRightCoords.x;
        for(let i = 1; i < oneSideHoleCount - 1; i++){
            const y = topLeftCoords.y + i * stepSize;
            holePositions.push({
                x: leftX,
                y
            });
            holePositions.push({
                x: rightX,
                y
            });
        }
    }
    return holePositions;
};

//# sourceMappingURL=hole-positions.js.map